import { Download, FileText } from 'lucide-react'

import { Badge } from '../ui/badge'
import { Button } from '../ui/button'

export interface ControlledDrug {
  id: number
  date: string
  ticket: string
  product: string
  quantity: number
  customer: string
  prescription: string
  seller: string
}

interface ControlledDrugsTableProps {
  data: ControlledDrug[]
}

export function ControlledDrugsTable({
  data,
}: ControlledDrugsTableProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-medium text-header-foreground">
            Registro de Medicamentos Controlados
          </h3>

          <p className="mt-1 text-sm text-mute-description">
            {data.length} registros en el periodo seleccionado
          </p>
        </div>

        <div className="flex gap-2">
          <Button variant="outline">
            <Download className="mr-2 h-4 w-4" />
            Exportar a Excel
          </Button>

          <Button variant="outline">
            <FileText className="mr-2 h-4 w-4" />
            Exportar a PDF
          </Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-border bg-card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-border bg-table-header-bg text-table-header-foreground">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Fecha de venta
                </th>

                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Ticket
                </th>

                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Producto
                </th>

                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Cantidad
                </th>

                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Receta
                </th>

                <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                  Vendedor
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-border">
              {data.map((drug) => (
                <tr
                  key={drug.id}
                  className="transition-colors hover:bg-table-row-hover"
                >
                  <td className="px-4 py-4 text-sm text-table-foreground">
                    {drug.date}
                  </td>

                  <td className="px-4 py-4 text-sm font-medium text-table-foreground">
                    {drug.ticket}
                  </td>

                  <td className="px-4 py-4 text-sm text-table-foreground">
                    {drug.product}
                  </td>

                  <td className="px-4 py-4 text-sm text-table-foreground">
                    {drug.quantity}
                  </td>

                  <td className="px-4 py-4">
                    <Badge className="bg-red-100 text-red-700">
                      {drug.prescription}
                    </Badge>
                  </td>

                  <td className="px-4 py-4 text-sm text-table-foreground">
                    {drug.seller}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}